import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Label,
  UncontrolledTooltip,
} from "reactstrap";

import { withTranslation } from "react-i18next";

import {
  selectStyle,
  getOptions,
  setClassName,
  renderButtons,
} from "../../Libs/CrudUtils/crudUtils";

import { showToast } from "../../Libs/CustomMethods/showToast";

import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import { schemaShow } from "./MuralValidation.js";

import Select from "react-select";

import {
  getDataShow,
  setDataShow,
  dataCreate,
  dataEdit,
  setDataIndex,
  apiReset,
} from "../../store/murals/actions";
import { isArray } from "../../Libs/CustomMethods/customMethods";

let validFields = {};

const NewMural = ({ t }) => {
  let { idData } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schemaShow),
  });

  const [dataValue, setDataValue] = useState(null);
  const [dataValueBk, setDataValueBk] = useState(null);
  const [enableSubmit, setEnableSubmit] = useState(false);

  // #BEGIN - Editable variables

  const mainPath = "/murals";
  const mainTitle = t("Murals");
  const path = "/mural";
  const pathTitle = t("Mural");

  const {
    dataShow,
    dataForm,
    loadingDataShow,
    loadingDataCreate,
    loadingDataEdit,
    success,
    error,
  } = useSelector((state) => state.Murals);

  const responseToYup = (data) => {
    let objParsed = {
      category: data?.category,
      global: data?.global,
      skills: data?.skills_id,
      title: data?.info?.title,
      url: data?.info?.url,
      type: data?.info?.type,
      src: data?.info?.src,
      autoWidth: !data?.info?.width,
      width: data?.info?.width || null,
      autoHeight: !data?.info?.height,
      height: data?.info?.height || null,
    };
    return objParsed;
  };

  const yupToRequest = (data) => {
    let info = {};
    switch (data?.category) {
      case "link":
        info = {
          title: data?.title,
          url: data?.url,
        };
        break;
      case "embed":
        info = {
          title: data?.title,
          type: data?.type,
          src: data?.src,
          width: data?.width || 0,
          height: data?.height || 0,
        };
        break;
      default:
        break;
    }
    let objParsed = {
      category: data?.category,
      global: data?.global,
      skills_id: data?.skills,
      info: info,
    };
    return objParsed;
  };

  const renderSwitchCategory = (category) => {
    switch (category) {
      case "link":
        return (
          <>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label>{t("Title") + " *"}</Label>
                  <input
                    ref={() => register({ name: "title" })}
                    type="text"
                    className={setClassName(errors.title, "form-control")}
                    placeholder={t("Enter title")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("title", value, dataValueBk);
                    }}
                    value={dataValue?.title ?? ""}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.title?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label>{t("URL") + " *"}</Label>
                  <input
                    ref={() => register({ name: "url" })}
                    type="text"
                    className={setClassName(errors.url, "form-control")}
                    placeholder={t("Enter url")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("url", value, dataValueBk);
                    }}
                    value={dataValue?.url ?? ""}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.url?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </>
        );
      case "embed":
        return (
          <>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label>{t("Title") + " *"}</Label>
                  <input
                    ref={() => register({ name: "title" })}
                    type="text"
                    className={setClassName(errors.title, "form-control")}
                    placeholder={t("Enter title")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("title", value, dataValueBk);
                    }}
                    value={dataValue?.title ?? ""}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.title?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup className="select2-container">
                  <div>
                    <Label>{t("Type") + " *"}</Label>
                    <i
                      className="fas fa-info-circle px-2 pointer"
                      id="type-tooltip"
                    />
                    <UncontrolledTooltip placement="auto" target="type-tooltip">
                      {`${t(
                        "Select iframe if you want to show other page on dashboard. Ex: https://datastudio.google.com/. Supported video formats: mp4, wbm, ogg"
                      )}`}
                    </UncontrolledTooltip>
                  </div>
                  <Select
                    ref={() => register({ name: "type" })}
                    classNamePrefix="select2-selection"
                    className={setClassName(errors.type, " select2-selection")}
                    styles={selectStyle}
                    placeholder={t("Choose") + "..."}
                    options={getOptions(dataForm?.types.map((e) => ({ id: e, name: e })), loadingDataShow)}
                    onChange={(e) => {
                      let value = e?.value;
                      updateValue("type", value, dataValueBk);
                    }}
                    value={
                      getOptions(dataForm?.types.map((e) => ({ id: e, name: e })), loadingDataShow)?.find(
                        (e) => e.value === dataValue?.type
                      ) ?? null
                    }
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.type?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <Label>{t("Src") + " *"}</Label>
                  <input
                    ref={() => register({ name: "src" })}
                    type="text"
                    className={setClassName(errors.src, "form-control")}
                    placeholder={t("Enter src. Ex: https://www.google.com")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("src", value, dataValueBk);
                    }}
                    value={dataValue?.src ?? ""}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.src?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <div className="d-flex justify-content-between">
                    <Label>{t("Width (px)") + " *"}</Label>
                    <div ref={() => register({ name: "autoWidth" })}className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={dataValue?.autoWidth ?? false}
                        readOnly
                      />
                      <label
                        className="custom-control-label"
                        onClick={() => {
                          updateValue(
                            "autoWidth",
                            !dataValue?.autoWidth,
                            dataValueBk
                          );
                          updateValue("width", null, dataValueBk);
                        }}
                      >
                        {t("Auto")}
                      </label>
                    </div>
                  </div>
                  <input
                    ref={() => register({ name: "width" })}
                    type="number"
                    className={setClassName(errors.width, "form-control")}
                    placeholder={t("Enter width")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("width", value, dataValueBk);
                    }}
                    value={dataValue?.width ?? ""}
                    disabled={dataValue.autoWidth}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.width?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <FormGroup>
                  <div className="d-flex justify-content-between">
                    <Label>{t("Height (px)") + " *"}</Label>
                    <div ref={() => register({ name: "autoHeight" })} className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        checked={dataValue?.autoHeight ?? false}
                        readOnly
                      />
                      <label
                        className="custom-control-label"
                        onClick={() => {
                          updateValue(
                            "autoHeight",
                            !dataValue?.autoHeight,
                            dataValueBk
                          );
                          updateValue("height", null, dataValueBk);
                        }}
                      >
                        {t("Auto")}
                      </label>
                    </div>
                  </div>
                  <input
                    ref={() => register({ name: "height" })}
                    type="number"
                    className={setClassName(errors.height, "form-control")}
                    placeholder={t("Enter height")}
                    onChange={(e) => {
                      let value = e?.target?.value;
                      updateValue("height", value, dataValueBk);
                    }}
                    value={dataValue?.height ?? ""}
                    disabled={dataValue.autoHeight}
                  />
                  <div className="invalid-feedback d-block">
                    {t(errors.height?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </>
        );
      default:
        return <></>;
    }
  };

  const renderInputs = () => (
    <Row className="mb-3">
      <Col lg="6">
        <Row>
          <Col xs="12">
            <FormGroup className="select2-container">
              <div className="d-flex justify-content-between w-100">
                <div>
                  <Label className="control-label">{t("Skill")}</Label>
                  <i
                    className="fas fa-info-circle px-2 pointer"
                    id="skill-tooltip"
                  />
                  <UncontrolledTooltip placement="auto" target="skill-tooltip">
                    {`${t("Select the skills of")} ${pathTitle} ${t(
                      "or enable global mode so that"
                    )} ${pathTitle} ${t(
                      "is displayed for all skills. To select the skills first disable the global mode"
                    )}`}
                  </UncontrolledTooltip>
                </div>
                <div
                  ref={() => register({ name: "global" })}
                  className="custom-control custom-checkbox"
                >
                  <input
                    type="checkbox"
                    className={setClassName(
                      errors.global,
                      "custom-control-input"
                    )}
                    checked={dataValue?.global ?? false}
                    readOnly
                  />
                  <label
                    className="custom-control-label"
                    onClick={() => {
                      updateValue("global", !dataValue?.global, dataValueBk);
                      updateValue("skills", [], dataValueBk);
                    }}
                  >
                    {t("Global")}
                  </label>
                </div>
              </div>
              <Select
                ref={() => register({ name: "skills" })}
                classNamePrefix="select2-selection"
                className={setClassName(
                  errors.skills,
                  `select2-selection ${dataValue?.global ? "isDisabled" : ""}`
                )}
                placeholder={t("Select") + "..."}
                options={getOptions(dataForm?.skills, loadingDataShow)}
                onChange={(e) => {
                  let value = e ? e.map((item) => item.value) : [];
                  updateValue("global", false, dataValueBk);
                  updateValue("skills", value, dataValueBk);
                }}
                value={getOptions(dataForm?.skills, loadingDataShow).filter(
                  (element) => dataValue?.skills?.includes(element.value)
                )}
                isDisabled={dataValue?.global}
                isMulti
              />
              <div className="invalid-feedback d-block">
                {t(errors?.global?.message)} {t(errors?.skills?.message)}
              </div>
            </FormGroup>
          </Col>
          <Col xs="12">
            <FormGroup className="select2-container">
              <Label>{t("Category") + " *"}</Label>
              <Select
                ref={() => register({ name: "category" })}
                classNamePrefix="select2-selection"
                className={setClassName(errors.category, " select2-selection")}
                styles={selectStyle}
                placeholder={t("Choose") + "..."}
                options={getOptions(dataForm?.categories?.map((e) => ({ id: e, name: e })), loadingDataShow)}
                onChange={(e) => {
                  let value = e?.value;
                  updateValue("category", value, dataValueBk);
                }}
                value={
                  getOptions(dataForm?.categories?.map((e) => ({ id: e, name: e })), loadingDataShow)?.find(
                    (e) => e.value === dataValue?.category
                  ) ?? null
                }
              />

              <div className="invalid-feedback d-block">
                {t(errors.category?.message)}
              </div>
            </FormGroup>
          </Col>
        </Row>
        {renderSwitchCategory(dataValue?.category)}
      </Col>
    </Row>
  );

  // #END - Editable variables

  const handleCreateEdit = (data) => {
    let obj = yupToRequest(data);
    if (idData) {
      dispatch(dataEdit(idData, obj));
    } else {
      dispatch(dataCreate(obj));
    }
  };

  const updateEnableSubmit = (target, value, data) => {
    let { [target]: tg, ...rest } = validFields;

    let sortedData = isArray(value) ? value.sort() : value;
    let sortedDataBk = isArray(data?.[target])
      ? data?.[target].sort()
      : data?.[target];

    let isEqual = JSON.stringify(sortedDataBk) === JSON.stringify(sortedData);

    validFields = isEqual ? { ...rest } : { ...validFields, [target]: value };

    let enable = Object.keys(validFields)?.length > 0;
    setEnableSubmit(enable);
  };

  const updateValue = useCallback(
    (target, value, data) => {
      updateEnableSubmit(target, value, data);
      setDataValue((prev) => ({
        ...prev,
        [target]: value,
      }));
    },
    [setValue]
  );

  const updateValueBk = useCallback((data) => {
    let obj = responseToYup(data);
    setDataValueBk(obj);
  }, []);

  const onToastHidden = useCallback(() => {
    dispatch(apiReset());
    if (success) {
      dispatch(setDataShow({ show: null, form: dataForm }));
      dispatch(setDataIndex({ index: null, form: dataForm }));
      history.push(mainPath);
    }
  }, [dispatch, history, success, dataForm]);

  useEffect(() => {
    dataValueBk &&
      Object.entries(dataValueBk).forEach((item) =>
        updateValue(item[0], item[1], dataValueBk)
      );
  }, [dataValueBk, updateValue]);

  useEffect(() => {
    if (dataValue) {
      Object.entries(dataValue).forEach((item) =>
        setValue(item[0], item[1], {
          shouldValidate: item[1],
        })
      );
    }
  }, [dataValue, setValue]);

  useEffect(() => {
    updateValueBk(dataShow);
  }, [dataShow, updateValueBk]);

  useEffect(() => {
    if (idData) {
      dataShow?.id !== idData && dispatch(getDataShow(idData, true));
    } else {
      dataForm
        ? dispatch(setDataShow({ show: null, form: dataForm }))
        : dispatch(getDataShow(null, true));
    }
  }, [dataForm, dataShow?.id, dispatch, idData]);

  useEffect(() => {
    success && showToast(t(success), "success", onToastHidden);
  }, [success, onToastHidden, t]);
  useEffect(() => {
    error && showToast(t(error), "error", onToastHidden);
  }, [error, onToastHidden, t]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath={mainPath}
            path={path}
            title={mainTitle}
            breadcrumbItem={
              idData
                ? t("Edit") + " " + pathTitle
                : t("Create") + " " + pathTitle
            }
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(handleCreateEdit)}>
                    {renderInputs()}
                    {renderButtons(
                      enableSubmit,
                      loadingDataCreate || loadingDataEdit,
                      mainPath,
                      null,
                      t
                    )}
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewMural);
